import { Flex, Tooltip } from "antd"
import styles from "./index.module.css"
import PropTypes from "prop-types"
import BookingConflictWarning from "pagesV2/pro/Calendar/Tooltips/BookingConflictWarning"

const EventBlock = ({
  event,
  eventColor,
  eventBorderColor,
  conflict,
  setIsBookingModalOpen,
  setSelectedBookingId,
  fullHeight,
  multipleInSlot,
  compact
}) => {
  const { id, startLabel, endLabel, title } = event || {}

  const handleClick = () => {
    setIsBookingModalOpen(true)
    setSelectedBookingId(event?.id)
  }

  const timeRange = startLabel && endLabel ? `${startLabel} – ${endLabel}` : null
  const tooltipTitle = [timeRange, title].filter(Boolean).join("\n")

  let timeClassName = styles.eventTime
  if (compact) timeClassName = styles.eventTimeCompact
  else if (multipleInSlot) timeClassName = styles.eventTimeWrap

  let titleClassName = styles.eventTitle
  if (compact) titleClassName = styles.eventTitleCompact
  else if (multipleInSlot) titleClassName = styles.eventTitleWrap

  const blockClassName = compact ? `${styles.eventBlock} ${styles.eventBlockCompact}` : styles.eventBlock

  return (
    <Tooltip title={tooltipTitle} mouseEnterDelay={0.5}>
      <button
        type="button"
        key={id || title + startLabel + endLabel}
        className={blockClassName}
        style={{
          backgroundColor: eventColor,
          ...(fullHeight ? { height: "100%" } : {}),
          ...(multipleInSlot ? { whiteSpace: "normal", wordBreak: "break-word" } : {})
        }}
        onClick={handleClick}
      >
        <Flex align="center" justify="space-between" gap={compact ? 2 : 4}>
          <span className={timeClassName}>{startLabel} - {endLabel}</span>
          {conflict ? <BookingConflictWarning /> : null}
        </Flex>
        <span className={titleClassName}>{title}</span>
      </button>
    </Tooltip>
  )
}

EventBlock.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    startLabel: PropTypes.string,
    endLabel: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string
  }),
  eventColor: PropTypes.string,
  eventBorderColor: PropTypes.string,
  setIsBookingModalOpen: PropTypes.func,
  setSelectedBookingId: PropTypes.func,
  conflict: PropTypes.bool,
  fullHeight: PropTypes.bool,
  multipleInSlot: PropTypes.bool,
  compact: PropTypes.bool
}

export default EventBlock
